import { render, staticRenderFns } from "./hotel-system-auth.vue?vue&type=template&id=4830c5c4&scoped=true"
import script from "./hotel-system-auth.vue?vue&type=script&lang=js"
export * from "./hotel-system-auth.vue?vue&type=script&lang=js"
import style0 from "./hotel-system-auth.vue?vue&type=style&index=0&id=4830c5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830c5c4",
  null
  
)

export default component.exports